import { Booking, Course, Order } from '@shared/types';
import { FunctionComponent } from 'react';
import styles from '../../BookingSideSummary.module.css';

type OnRequestPricingLabelProps = {
    course: Course;
    bookingOrOrder?: Booking | Order;
};

const OnRequestPricingLabel: FunctionComponent<OnRequestPricingLabelProps> = ({
    course,
    bookingOrOrder,
}) => {
    if (bookingOrOrder) {
        return null;
    }
    if (course.type !== 'on-request') {
        return null;
    }

    if (course.pricing_option.type === 'price-on-enquiry') {
        return (
            <div className={styles.summary_costs}>
                <span>Price on enquiry</span>
            </div>
        );
    }

    if (course.pricing_option.type === 'price-range') {
        return (
            <div className={styles.summary_costs}>
                <span>
                    £{course.pricing_option.minimumPrice} - £{course.pricing_option.maximumPrice}
                </span>
            </div>
        );
    }

    return null;
};

export default OnRequestPricingLabel;
